<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    :title="titles[updateType]"
  >
    <el-form ref="form" :model="initForm" :rules="rules">
      <el-form-item label="告警名称" prop="name" label-width="180px">
        <el-input v-model="initForm.name"></el-input>
      </el-form-item>
      <el-form-item label="告警码" prop="code" label-width="180px">
        <el-input v-model="initForm.code"></el-input>
      </el-form-item>
      <el-form-item label="告警等级" prop="level" label-width="180px">
        <el-select v-model="initForm.level" placeholder="">
          <el-option
            style="font-size:16px;"
            v-for="alarmlevel in alarmlevels"
            :label="alarmlevel.Name"
            :key="alarmlevel.ID"
            :value="alarmlevel.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="告警阈值" label-width="180px">
        <el-input v-model="initForm.threshold"></el-input>
      </el-form-item>
      <el-form-item label="告警规则说明" label-width="180px">
        <el-input v-model="initForm.description"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Flags } from "@/components/Index/data.js";
import { alarmlevelsList } from "@/components/Index/data.js";
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [{ required: true, message: "请输入告警名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入告警码", trigger: "blur" }],
        level: [{ required: true, message: "请输入告警等级", trigger: "blur" }]
      },
      Flags: Flags,
      titles: {
        add: "新增告警配置",
        edit: "编辑告警配置"
      },
      alarmlevels: alarmlevelsList.slice(0, 6)
    };
  },
  mounted() {
    this.initForm.level = this.initForm.level.toString();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        if (this.updateType === "edit") {
          let url = "alarm_types/" + this.initForm.id + "/";
          this.$http["put"](url, this.initForm, () => {
            this.$baseNotice.message("编辑成功");
            this.$emit("close");
            this.$emit("update");
          });
        } else {
          let url = "alarm_types/";
          this.$http["post"](url, this.initForm, () => {
            this.$baseNotice.message("新增成功");
            this.$emit("close");
            this.$emit("update");
          });
        }
      });
    }
  }
};
</script>
